import { useLayoutEffect, useRef, useState } from 'react';

export const TASKBAR_HEIGHT = 28;
export function clampWindow(rect, width, height) {
    return { left: Math.max(0, Math.min(rect.left, width - rect.width)),
        top: Math.max(0, Math.min(rect.top, height - TASKBAR_HEIGHT - rect.height)) };
}
// Normalize centered initial positions once, then use bounded pixel positions.
// Pointer capture keeps drag release/cancellation local to its title bar.
export function useWindowPlacement(ref, active, draggable) {
    const [position, setPosition] = useState(null);
    const drag = useRef(null);
    useLayoutEffect(() => {
        const fit = () => {
            if (!ref.current) return;
            const next = clampWindow(ref.current.getBoundingClientRect(), window.innerWidth, window.innerHeight);
            setPosition(prev => prev?.left === next.left && prev?.top === next.top ? prev : next);
        };
        fit();
        const observer = new ResizeObserver(fit);
        observer.observe(ref.current);
        window.addEventListener('resize', fit);
        return () => { observer.disconnect(); window.removeEventListener('resize', fit); };
    }, [ref, active]);
    const end = () => { drag.current = null; };
    return {
        placement: position ? { ...position, transform: 'none' } : {},
        handlers: {
            onPointerDown: e => {
                if (!draggable || e.button !== 0 || e.target.closest('button')) return;
                const rect = ref.current.getBoundingClientRect();
                if (rect.width >= window.innerWidth && rect.height >= window.innerHeight - TASKBAR_HEIGHT) return;
                drag.current = { x: e.clientX, y: e.clientY, rect };
                e.currentTarget.setPointerCapture(e.pointerId);
                e.preventDefault();
            },
            onPointerMove: e => {
                if (!drag.current) return;
                const { x, y, rect } = drag.current;
                setPosition(clampWindow({ width: rect.width, height: rect.height,
                    left: rect.left + e.clientX - x, top: rect.top + e.clientY - y }, window.innerWidth, window.innerHeight));
            },
            onPointerUp: end, onPointerCancel: end, onLostPointerCapture: end,
        },
    };
}
